'use strict';
'use es6';

// eslint-disable-next-line no-unused-vars

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = DOMElement;
function DOMElement(props, propName, componentName, location) {
  var value = props[propName];
  if (!(value && value.nodeType === 1)) {
    return new Error('Invalid prop `' + propName + '` supplied to ' + componentName + ', expected ' + ('a DOM Element, received `' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '`'));
  }
  return null;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.43/js/propTypes/DOMElement.js
// module id = 191
// module chunks = 0